import styled from "styled-components";
import { Color } from 'styles';


export const StyledWrapper = styled.section`
  background-color: ${Color.White};
  padding: 225px 0;
  width: 100%;
`;

export const StyledHeaderWrapper = styled.header`
`;

export const StyledTextWrapper = styled.div`
    padding: 30px 0 60px;
`;


// WEBPACK FOOTER //
// ./src/routes/invoice/invoice.style.js